export default "__VITE_ASSET__QwSxIITv__"